import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import testsActionCreators from "../../store/tests/action-creators";
import testActionCreators from "../../store/tests/action-creators";
import testTemplateActionCreators from "../../store/test-templates/action-creators";
import '../test-templates/TestTemplates.scss';
import './TestList.scss';
import {Alert, Input} from "reactstrap";
import {withRouter} from "react-router-dom";
import classNames from 'classnames'
import oitsActionCreators from "../../store/oits/action-creators";
import TestAnalytics from './TestAnalytics';
import departmentSettingsSelectors from "../../store/department-settings/selectors";

function mapStateToProps(state) {
  return {
    tests: state.tests.list,
    userContext: state.common.userContext,
    oits: state.oits.list,
    testTemplates: state.testTemplates.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTests() {
      return dispatch(testsActionCreators.fetchMyTests());
    },
    fetchOitTests(guid) {
      return dispatch(testsActionCreators.fetchTestsForUser(guid));
    },
    fetchTestTemplates() {
      return dispatch(testTemplateActionCreators.fetchTestTemplates());
    },
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    deleteTest(testId) {
      return dispatch(testActionCreators.deleteTest(testId));
    },
  };
}

class TestTemplates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isCreatingTestTemplate: false,
      isLoadingCreate: false,
      selectedOit: '',
      selectedTestTemplate: '',
      analyticsQuestions: [],
      analyticsTests: [],
      analyticsResultsMap: {},
      showTestsList: true,
    }
  }

  get filteredTests() {
    return this.props.tests.filter(tt => tt.test_template && tt.test_template.id === this.state.selectedTestTemplate || !this.state.selectedTestTemplate);
  }

  componentDidMount() {
    if (this.props.userContext.hasScope('oit')) {
      this.setState({
        isLoading: true
      });

      this.props.fetchTests()
        .then(() => {
          this.setState({
            isLoading: false
          });
        })
        .catch(() => {
          this.setState({
            isLoading: false
          });
        })
    } else {
      this.props.loadOitsContainer(this.props.userContext.scope)
        .then(() => {
          this.props.fetchTestTemplates();

          if (this.props.oits && this.props.oits.length === 1) {
            this.setSelectedOit(this.props.oits[0].guid);
          }
        });
    }
  }

  setSelectedOit(oitGuid) {
    this.setState({
      selectedOit: oitGuid
    });

    this.props.fetchOitTests(oitGuid)
  }

  setSelectedTestTemplate(testTemplateId) {
    this.setState({
      selectedTestTemplate: testTemplateId
    });
  }

  showList() {
    this.setState({
      showTestsList: true
    });
  }

  isCorrectAnswer(answersList, qeustionAnswers) {
    if (!answersList) {
      return false
    }

    if (!qeustionAnswers) {
      return answersList.correct
    }

    let correctAnswers = qeustionAnswers
      .filter(a => a.isCorrect)
      .map(a => a.id)
      .sort()
      .reduce((answer, a) => answer + a, '');

    let answers = answersList.answers.reduce((answer, a) => answer + a, '');

    return correctAnswers === answers;
  }

  generateTestsAnalytics() {
    const oitFilteredTests = this.props.tests.filter(tt => tt.test_template.id === this.state.selectedTestTemplate &&
      tt.status === 'completed');

    let analyticsQuestions = [];
    oitFilteredTests.reduce(function (acc, test) {
      test.questions.reduce(function (acc, question) {
        if (!analyticsQuestions.find(q => q.id === question.id)) {
          analyticsQuestions.push(question);
        }

        return acc;
      }, []);

      return acc;
    }, []);

    const that = this;
    let analyticsResultsMap = [];
    oitFilteredTests.reduce(function (acc, test) {
      test.questions.reduce(function (acc, question) {
        const currentQuestionAnswers = test.questions.find(q => q.id === question.id).answers;
        const currentQuestionAnsweredList = test.answers[question.id];

        analyticsResultsMap[test.id + '' + question.id] = that.isCorrectAnswer(currentQuestionAnsweredList, currentQuestionAnswers) + '';

        return acc;
      }, []);

      return acc;
    }, []);

    this.setState({
      analyticsQuestions,
      analyticsTests: oitFilteredTests,
      analyticsResultsMap,
      showTestsList: false,
    });
  }

  openTest(tt) {
    this.props.history.push(`/tests/${tt.id}`);
  }

  deleteTest(test) {
    this.props.deleteTest(test.id);
  }

  timeSpent(test) {
    if (test.finished_at) {
      const finishedAtMomentObj = moment(test.finished_at);
      const startedAtMomentObj = moment(test.started_at);

      const milisecondsDuration = moment.duration(finishedAtMomentObj.diff(startedAtMomentObj)).asMilliseconds();

      const secondsDuration = milisecondsDuration  / 1000;
      const minutes = Math.floor(secondsDuration / 60);
      const seconds = Math.floor(secondsDuration % 60);

      const minutesParsed = minutes < 10 ? `0${minutes}` : minutes;
      const secondsParsed = seconds < 10 ? `0${seconds}` : seconds;

      return `${minutesParsed}:${secondsParsed}`;
    }

    return '';
  }

  testStatus(test) {
    if (test.status === 'completed') {
      return test.passed ? 'passed' : 'failed'
    }

    if (test.status === 'waiting') {
      return 'Needs grading';
    }

    return test.status;
  }

  get filteredTestTemplates() {
    return this.props.testTemplates.filter(tt => tt.status !== 'archived')
  }


  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">Tests</h4>
        </div>

        <div className="test-templates app-content">
          <div className="test-templates-card">
            {!this.props.userContext.hasScope('oit') && (
              <div className="form">
                <div className="form-group">
                  <Input
                    name="type"
                    onChange={event =>
                      this.setSelectedOit(event.target.value)
                    }
                    type="select"
                    value={this.state.selectedOit}
                  >
                    <option defaultValue={''}>Select {this.props.oitShortLabel}</option>
                    {this.props.oits && this.props.oits.map(oit => (
                      <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                    ))}
                  </Input>
                </div>

                <div className="form-group">
                  <Input
                    name="type"
                    onChange={event =>
                      this.setSelectedTestTemplate(event.target.value)
                    }
                    type="select"
                    value={this.state.selectedTestTemplate}
                  >
                    <option value=''>Select Test Template</option>
                    {this.filteredTestTemplates && this.filteredTestTemplates.map(tt => (
                      <option key={tt.id} value={tt.id}>{tt.title}</option>
                    ))}
                  </Input>
                </div>

                <div className="btns-container">
                  {this.state.selectedTestTemplate && this.state.selectedOit &&
                    <div className="form-group">
                      <button className="button small primary" onClick={() => this.generateTestsAnalytics()}>
                        Generate Test Analytics
                      </button>

                      <button className="button small primary view-list-btn" onClick={() => this.showList()}>
                        View List
                      </button>
                    </div>
                  }
                </div>
              </div>
            )}

            <div className="table-scrollable">
              {this.state.showTestsList && this.filteredTests.length ? (
                <table className="table table-stripped layout-auto">
                  <thead>
                  <tr>
                    <th>
                      <div className="header">
                        <span>Title</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Date</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Score </span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Time</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Passed</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Actions </span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.filteredTests.map(tt => (
                    <tr key={tt.id}>
                      <td>
                        {tt.test_template.title}
                      </td>
                      <td>
                        {tt.schedule &&
                        <span>{moment(tt.schedule).format('MM/DD/YYYY')}</span>
                        }
                      </td>
                      <td>{Math.round(tt.score)}</td>
                      <td>{this.timeSpent(tt)}</td>
                      <td className={classNames({
                        pending: this.testStatus(tt) === 'pending',
                        passed: this.testStatus(tt) === 'passed',
                        failed: this.testStatus(tt) === 'failed',
                        waiting: tt.status === 'waiting',
                      })}>
                        {this.testStatus(tt)}
                      </td>
                      <td>
                        {tt.status === 'pending' && this.props.userContext.hasScope('oit') &&
                        (
                          <button className="button small primary" onClick={() => this.openTest(tt)}>
                            <i className="fa fa-edit"/>
                            Take test
                          </button>
                        )}
                        {tt.status === 'completed' &&
                        (
                          (
                            <button className="button small primary" onClick={() => this.openTest(tt)}>
                              <i className="fa fa-file-archive-o"/>
                              View result
                            </button>
                          )
                        )}
                        {tt.status === 'pending' && this.props.userContext.hasScope(['fto', 'ftoc']) &&
                        (
                          <button className="button small danger" onClick={() => this.deleteTest(tt)}>
                            <i className="fa fa-trash"/>
                            Delete Test
                          </button>
                        )}
                        {tt.status === 'waiting' && this.props.userContext.hasScope(['fto', 'ftoc']) &&
                        (
                          <button className="button small secondary" onClick={() => this.openTest(tt)}>
                            <i className="fa fa-edit"/>
                            Grade Test
                          </button>
                        )}
                        {tt.status === 'started' && this.props.userContext.hasScope(['oit']) &&
                        (
                          <button className="button small secondary" onClick={() => this.openTest(tt)}>
                            <i className="fa fa-edit"/>
                            Continue test
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              ) : ((!this.props.userContext.hasScope('oit') && this.selectedOit) || this.props.userContext.hasScope('oit')) &&
                <Alert color="primary">No tests</Alert>}
            </div>


            {!this.state.showTestsList &&
            <TestAnalytics
              questions={this.state.analyticsQuestions}
              tests={this.state.analyticsTests}
              resultsMap={this.state.analyticsResultsMap}
            />
            }
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestTemplates));
